module.exports = __webpack_public_path__ + "img/4.fabc972c.jpg";